import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useUserAuth } from "../context/UserAuthContext";
import Context from "../context/Context";
export default function useShowcasePageScroll(
  pageNumber,
  token,
  likeMap,
  setLikeMap,
  viewMore
) {
  const [hasMore, setHasMore] = useState(false);
  const [dataloading, setDataLoading] = useState(true);
  const [error, setError] = useState(false);
  const { imageGalleryContents, setImageGalleryContents } = useContext(Context);
  const { guestModeEnabled } = useUserAuth();
  useEffect(() => {
    if (imageGalleryContents?.length / 10 >= pageNumber) {
      setHasMore(true);
      setDataLoading(false);
      return;
    }
    setDataLoading(true);
    setError(false);
    const updatedLikeMap = new Map(likeMap);
    let cancel;
    let config = "";
    if (guestModeEnabled) {
      config = {
        method: "get",
        url: `${process.env.REACT_APP_GET_SHOWCASE_ENTRIES_NOUSER}`,
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      };
    } else {
      config = {
        method: "get",
        url: `${process.env.REACT_APP_GET_SHOWCASE_ENTRIES}?page=${pageNumber}&limit=10`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      };
    }

    axios(config)
      .then((res) => {
        let entris = guestModeEnabled ? res?.data : res.data.data;
        entris.forEach((item) => {
          if (updatedLikeMap.has("con" + item?.entryId)) {
            const obj = updatedLikeMap.get("con" + item?.entryId);
            let count = item?.likesCount ? item?.likesCount : 0;
            obj.likesCount = obj.likesCount ? obj.likesCount : count;
            updatedLikeMap.set("con" + item?.entryId, obj);
          } else {
            updatedLikeMap.set("con" + item?.entryId, {
              likesCount: item?.likesCount ? item?.likesCount : 0,
            });
          }
        });
        setLikeMap(updatedLikeMap);
        if (guestModeEnabled) {
          setImageGalleryContents(res?.data);
          setHasMore(false);
        } else {
          setImageGalleryContents((prevState) => [
            ...prevState,
            ...res?.data?.data,
          ]);
          setHasMore(res?.data?.data?.length > 0);
        }

        setDataLoading(false);
      })
      .catch((e) => {
        console.log(e);
        if (axios.isCancel(e)) return;
        setError(true);
        setDataLoading(false);
      });

    return () => cancel();
  }, [pageNumber, viewMore]);

  return { dataloading, error, imageGalleryContents, hasMore };
}
